
import Vue from "vue";
import OrderPathFilter from "./OrderPathFilter.vue";
import {
  normalizeOrderPathSelection,
  OrderPathFilterMode,
  OrderPathOption,
  OrderPathPresentationMode,
  transformOrderPathOptions,
} from "@/utils/orderPathFilter";

export default Vue.extend({
  name: "GlobalOrderPathFilter",
  components: {
    OrderPathFilter,
  },
  props: {
    orderPathOptions: {
      type: Array as () => OrderPathOption[],
      default: () => [],
    },
    orderPathFilterMode: {
      type: String as () => OrderPathFilterMode,
      default: "include",
    },
    orderPathPresentationMode: {
      type: String as () => OrderPathPresentationMode,
      default: "grouped",
    },
    selectedOrderPathKeys: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  data: () => ({
    dialog: false,
    draftOrderPathFilterMode: "include" as OrderPathFilterMode,
    draftOrderPathPresentationMode: "grouped" as OrderPathPresentationMode,
    draftSelectedOrderPathKeys: [] as string[],
  }),
  computed: {
    draftOrderPathOptions(): OrderPathOption[] {
      return transformOrderPathOptions(
        this.orderPathOptions,
        this.draftOrderPathPresentationMode
      );
    },
    isFilterActive(): boolean {
      return this.selectedOrderPathKeys.length > 0;
    },
    filterSummary(): string {
      if (this.selectedOrderPathKeys.length === 0) return "전체";

      const labels = this.orderPathOptions
        .filter((option) => this.selectedOrderPathKeys.includes(option.key))
        .map((option) => option.label);
      const visibleLabels = labels.slice(0, 2).join(", ");
      const remainingCount = Math.max(labels.length - 2, 0);
      const selection =
        visibleLabels || `${this.selectedOrderPathKeys.length}개 선택`;
      const suffix = remainingCount > 0 ? ` 외 ${remainingCount}` : "";
      const modeLabel =
        this.orderPathFilterMode === "exclude" ? "제외" : "선택";
      return `${modeLabel}: ${selection}${suffix}`;
    },
  },
  methods: {
    open() {
      this.resetDraft();
      this.dialog = true;
    },
    resetDraft() {
      this.draftOrderPathFilterMode =
        this.orderPathFilterMode === "exclude" ? "exclude" : "include";
      this.draftOrderPathPresentationMode =
        this.orderPathPresentationMode === "separate" ? "separate" : "grouped";
      this.draftSelectedOrderPathKeys = [...this.selectedOrderPathKeys];
    },
    updateDraftOrderPathFilterMode(mode: OrderPathFilterMode) {
      this.draftOrderPathFilterMode = mode;
    },
    updateDraftOrderPathPresentationMode(mode: OrderPathPresentationMode) {
      this.draftOrderPathPresentationMode = mode;
      this.draftSelectedOrderPathKeys = normalizeOrderPathSelection(
        this.draftSelectedOrderPathKeys,
        mode
      );
    },
    updateDraftSelectedOrderPathKeys(keys: string[]) {
      this.draftSelectedOrderPathKeys = [...keys];
    },
    clearDraft() {
      this.draftOrderPathFilterMode = "include";
      this.draftSelectedOrderPathKeys = [];
    },
    closeWithoutApplying() {
      this.resetDraft();
      this.dialog = false;
    },
    applyAndClose() {
      this.$emit(
        "update:orderPathPresentationMode",
        this.draftOrderPathPresentationMode
      );
      this.$emit("update:orderPathFilterMode", this.draftOrderPathFilterMode);
      this.$emit("update:selectedOrderPathKeys", [
        ...this.draftSelectedOrderPathKeys,
      ]);
      this.dialog = false;
    },
  },
});
